export default {
  props: {
    errorMessages: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
  },
  computed: {
    fieldClasses() {
      return {
        'pa-0': this.dense,
        'ma-0': this.dense,
        'v-input--required': this.required,
      };
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
  },
};
